import styled from "styled-components";

export const SVG = styled.svg`
  fill: currentColor;
  width: 1.5rem;
  height: 1.5rem;
  margin-left: 8px;
`;